import { render } from "./cell_obj.vue?vue&type=template&id=201bf275"
import script from "./cell_obj.vue?vue&type=script&lang=ts"
export * from "./cell_obj.vue?vue&type=script&lang=ts"

import "./cell_obj.vue?vue&type=style&index=0&id=201bf275&lang=less"
script.render = render

export default script